module.exports = __webpack_public_path__ + "static/img/disfinectType.7d940fb4.png";